import { axiosInstance } from './base'

export default {
  list() {
    return axiosInstance.get('countries')
  }
}
